import { http } from "../../utils/config";

const invoiceAPI = {
  exportAllParent: (id) => {
    return http.get(`/api/v1/invoices/export/parent/${id}/all`);
  },
  exportAll: (id) => {
    return http.get(`/api/v1/invoices/export/${id}/all`);
  },
  export: (id) => {
    return http.get(`/api/v1/invoices/export/${id}/one`);
  },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        let parsed = {};

        // Nếu backend trả về Blob (khi responseType: 'blob')
        if (data instanceof Blob) {
          try {
            const text = await data.text();
            parsed = JSON.parse(text);
          } catch (e) {
            console.error("Failed to parse Blob error:", e);
          }
        }

        // Lấy message ưu tiên: parsed.message > data.message
        const msg = parsed.message || data?.message;

        switch (status) {
          case 400:
            throw new Error(msg || "Dữ liệu không hợp lệ");
          case 401:
            throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403:
            throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404:
            throw new Error("Không tìm thấy thông tin");
          case 422:
            throw new Error(msg || "Dữ liệu không hợp lệ");
          case 500:
            throw new Error(msg || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(msg || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        // Network error
        throw new Error("Không thể kết nối đến server");
      } else {
        // Other error
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

// Wrapped API functions with error handling
export const invoiceAPIWithErrorHandling = {
  exportAll: withErrorHandling(invoiceAPI.exportAll),
  exportAllParent: withErrorHandling(invoiceAPI.exportAllParent),
  export: withErrorHandling(invoiceAPI.export),
};

export default invoiceAPI;
